// extracted by mini-css-extract-plugin
export var clickThrough = "_yz-2";
export var fallback = "_yz-5";
export var frame = "_yz-3";
export var frameCell = "_yz-1";
export var overlay = "_yz-4";
export var wrapper = "_yz-0";